namespace $ {
	export class $visavis_pie extends $visavis_plot_plotly {
		
		/**
		 * ```tree
		 * colorset /
		 * 	\#3e3f95
		 * 	\#c00
		 * 	\#FE9A2E
		 * 	\#090
		 * 	\#f0f
		 * 	\#09f
		 * 	\#666
		 * 	\#0f3
		 * 	\#0ff
		 * 	\#90c
		 * ```
		 */
		colorset() {
			return [
				"#3e3f95",
				"#c00",
				"#FE9A2E",
				"#090",
				"#f0f",
				"#09f",
				"#666",
				"#0f3",
				"#0ff",
				"#90c"
			] as readonly any[]
		}
	}
	
}

